import { api } from '@/shared/lib/api'
import { QueryMeta, useQuery } from '@tanstack/react-query'

export const useGetUsers = ({
    page = 1,
    pageSize = 10,
    q = '',
    enabled = true,
    regionIds,
    areaIds,
    projectId,
    meta,
}: {
    page?: number
    pageSize?: number
    q?: string
    projectId?: string
    enabled?: boolean
    regionIds?: string[]
    areaIds?: string[]
    meta?: QueryMeta
}) => {
    return useQuery({
        queryKey: ['users', page, pageSize, q, regionIds, areaIds, projectId],
        queryFn: () =>
            api.user.listAll({
                page: page,
                take: pageSize,
                q: q || undefined,
                regionIds: regionIds?.join(',') || undefined,
                areaIds: areaIds?.join(',') || undefined,
                projectId: projectId || undefined,
            }),
        enabled: enabled,
        staleTime: 10 * 60 * 1000, // 10 minutes - cache longer to reduce refetches
        gcTime: 15 * 60 * 1000, // 15 minutes - keep in cache even when unused
        meta,
    })
}
